import React, { useEffect, useState } from 'react';

function formatDate(iso) {
  if (!iso) return '-';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

const SiteMap = () => {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let isMounted = true;
    fetch('/sitemap.xml')
      .then((res) => res.text())
      .then((xmlText) => {
        if (!isMounted) return;
        const parser = new DOMParser();
        const doc = parser.parseFromString(xmlText, 'application/xml');
        const urlNodes = Array.from(doc.getElementsByTagName('url'));
        const rows = urlNodes.map((node) => {
          const loc = node.getElementsByTagName('loc')[0]?.textContent || '';
          const lastmod = node.getElementsByTagName('lastmod')[0]?.textContent || '';
          const priority = node.getElementsByTagName('priority')[0]?.textContent || '';
          return { loc, lastmod, priority };
        });
        setEntries(rows);
        setLoading(false);
      })
      .catch((e) => {
        if (!isMounted) return;
        setError('Failed to load sitemap.xml');
        setLoading(false);
      });
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 pt-24 pb-12">
      <div className="container max-w-6xl mx-auto px-4">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">Site Map</h1>
        {loading && (
          <div className="text-gray-600">Loading sitemap...</div>
        )}
        {error && (
          <div className="text-red-600 font-medium">{error}</div>
        )}
        {!loading && !error && (
          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">URL</th>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Last Modified</th>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Priority</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {entries.map((row, idx) => (
                    <tr key={`${row.loc}-${idx}`} className="hover:bg-gray-50">
                      <td className="px-4 py-3">
                        <a href={row.loc} className="text-green-700 hover:text-green-800 break-all">
                          {row.loc}
                        </a>
                      </td>
                      <td className="px-4 py-3 text-gray-700 whitespace-nowrap">{formatDate(row.lastmod)}</td>
                      <td className="px-4 py-3 text-gray-700 whitespace-nowrap">{row.priority || '-'}</td>
                    </tr>
                  ))}
                  {entries.length === 0 && (
                    <tr>
                      <td className="px-4 py-6 text-gray-600" colSpan={3}>No entries found in sitemap.xml</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SiteMap;


